module.exports = __webpack_public_path__ + "static/media/2@4x.c1ac2aa1.png";